<template>
  <v-autocomplete
      :items="items"
      item-value="id"
      item-text="billingName"
      no-data-text="Žiadne výsledky"
      :loading="loading"
      :disabled="loading"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <template
        v-slot:append-outer
    >
      <CreateOrganizer
          v-if="createButton"
          :icon="true"
          :small="true"
          @init="init"
      />

      &nbsp;

      <v-btn
          :small="true"
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          @click="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
  import Organizers from '@/services/organizers'

  import CreateOrganizer from '@/components/Organizers/Create'

  export default {
    name: 'Suggest',
    props: [
      'support',
      'createButton'
    ],
    components: {
      CreateOrganizer
    },
    data() {
      return {
        loading: false,
        organizers: []
      }
    },
    mounted() {
      this.init()
    },
    computed: {
      items() {
        return (
          typeof this.support === 'function'
            ? this.support(this.organizers)
            : this.organizers
        )
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      loadData() {
        this.loading = true

        Organizers
          .suggest()
          .then((response) => {
            this.organizers = response.data.data.organizers
          })
          .catch((error) => {
            switch (error.response.status) {
              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
